export const getNodeFromString = data => {
	if (typeof data === 'object') return data;

	const el = document.createElement('div');
	el.innerHTML = data;
	return el.firstElementChild;
};

export const generateSyncId = target => {
	if (!target.dataset.syncId) {
		let id;
		if (
			typeof crypto !== 'undefined' &&
			typeof crypto.randomUUID === 'function'
		) {
			id = crypto.randomUUID();
		} else {
			const now = Date.now ? Date.now() : new Date().getTime();
			const random = Math.random().toString(16).substr(2);
			id = `id-${now.toString(16)}-${random}`;
		}
		target.dataset.syncId = id;
	}
	return target.dataset.syncId;
};

export const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

export const waitForObject = async (
	obj,
	prop,
	count = 0,
	delays = [100, 200, 300],
) => {
	if (!obj[prop] && count <= 20) {
		const delay = delays[Math.min(Math.floor(count / 5), delays.length - 1)];
		await wait(delay);
		return waitForObject(obj, prop, count + 1, delays);
	}

	if (!obj[prop]) {
		return Promise.reject(new Error(`${prop} not available`));
	}

	return Promise.resolve(obj[prop]);
};

export default getNodeFromString;
